import { filterAllMateriais, getAllMateriais, saveMaterial, updateMaterial } from '@/services/api/material.js';
export const actions = {
  async getMateriaisByFilter(state, filter) {
    try {
      const dataList = await filterAllMateriais(filter);
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async getAllMateriais(state) {
    try {
      const dataList = await getAllMateriais();
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async saveMaterial(state, payload) {
    try {
      await saveMaterial(payload);
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async updateMaterial(state, payload) {
    try {
      await updateMaterial(payload);
    } catch (error) {
        /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  }
}
